import {currencyRate} from "./currencyRate";

export const calcBonus = ({
                              amountDeposit,
                              methodPayment,
                              rateCurrency,
                              minSumForBonus,
                              user,
                              accrualAmount,
                              accrualAmountSum
                          }) => {

    if (amountDeposit !== "") {

        const rate = currencyRate(methodPayment, rateCurrency)

        minSumForBonus = 3000 / rate;
        const convertedAmount = Math.round(amountDeposit * rate);

        // Вычисляем бонус
        const getBonusMultiplier = (amount: number): number => {
            if (user?.hasDepositBonus) return 0.5;
            if (amount >= 2000) return 0.15;
            if (amount >= 1000) return 0.1;
            if (amount >= 500) return 0.05;
            if (amount >= 100) return 0.02;
            return 0;
        };

        const bonusMultiplier = getBonusMultiplier(convertedAmount);
        const bonus = convertedAmount * bonusMultiplier;
        const personalBonus = convertedAmount * (user?.personalBonus ?? 0) / 100;

        accrualAmount = (bonus + personalBonus) / rate;
        accrualAmountSum = convertedAmount + bonus + personalBonus;
    }
    return {
        accrualAmount,
        accrualAmountSum,
        minSumForBonus
    };
}